import { css } from '@emotion/react';

const getCredentialsItemStyles = (forceBoldFirstLine: boolean = false) => ({
  itemWrapper: () => css`
    display: flex;
    gap: var(--cds-spacing-300);
  `,
  iconWrapper: () => css`
    height: 64px;
    width: 64px;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    background-color: var(--cds-color-grey-25);
    border-radius: 3px;
  `,
  detailsWrapper: () => css`
    display: flex;
    flex-direction: column;
    gap: var(--cds-spacing-100);
    flex-grow: 1;
    position: relative;

    /* Add the title font-weight here instead of on the <Typography> component, if the instituion is missing the second line will act as the title */
    ${forceBoldFirstLine &&
    css`
      p:first-of-type {
        font-weight: bold;
      }
    `}
  `,
});

export default getCredentialsItemStyles;
